import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import _ from "lodash";
import { Icon } from "@cdk-uip/react-icon";
import { b64toBlob } from "../../util/helpers";
import api from "../../api/candidate.resource";
import PersonalDetails from "./PersonalDetails";
import QualificationDetails from "./QualificationDetails";
import OrganizationDetails from "./OrganizationDetails";
import AddressDetails from "./AddressDetails";
import ViewUserDocuments from "../common/ViewUserDocuments";
import CDKSpinner from "../../images/CDKSpinner.gif";

export const CandidateReport = ({ history, location }) => {
  const [candidateData, setCandidateData] = useState({});
  const [loading, setLoading] = useState(true);
  const [documentsLoading, setDocumentsLoading] = useState(true);
  const [eventKey, setEventKey] = useState("candidateReport");
  const [userDocuments, setUserDocuments] = useState([]);

  const getCandidateDetails = async () => {
    try {
      const { state: { candidateId = "" } = {} } = location;
      const res = await api.getCandidateReportData(candidateId);
      setCandidateData(res.userDetails);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  const getCandidateDocuments = async () => {
    try {
      const { state: { candidateId = "" } = {} } = location;
      const resUserDocuments = await api.getUserDocuments(candidateId);
      if (resUserDocuments && !resUserDocuments.errorMessage) {
        const savedUserDocuments = resUserDocuments.map(file => {
          return new File([b64toBlob(file.byteData, file.type)], file.name, {
            type: file.type
          });
        });
        if (savedUserDocuments && savedUserDocuments.length)
          setUserDocuments(savedUserDocuments);
      }
    } catch (e) {
    } finally {
      setDocumentsLoading(false);
    }
  };

  useEffect(() => {
    getCandidateDetails();
    getCandidateDocuments();
  }, []);

  const handleSelect = eventKey =>
    eventKey === "candidateReport"
      ? setEventKey("candidateReport")
      : setEventKey("candidateDocuments");

  return loading ? (
    "Loading....."
  ) : (
    <div>
      <div className="headerIcons pt-3">
        <div className="container d-flex align-items-center">
          <Icon
            onClick={() => {
              history.goBack();
            }}
          >
            arrow_back
          </Icon>
          <Nav
            className="ml-3"
            variant="tabs"
            defaultActiveKey="candidateReport"
            onSelect={handleSelect}
          >
            <Nav.Item>
              <Nav.Link eventKey="candidateReport">Candidate Details</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="candidateDocuments">
                Candidate Documents
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      </div>
      {eventKey === "candidateReport" ? (
        <React.Fragment>
          <div className="container text-right">
            <Icon
              align="right"
              className="headerIcons text-right"
              onClick={() => {
                window.print();
              }}
            >
              print
            </Icon>
          </div>
          <PersonalDetails personalDetails={candidateData} />
          <QualificationDetails
            qualificationDetails={candidateData.qualifications}
          />
          <OrganizationDetails
            organizationDetails={candidateData.organizationDetails}
          />
          <AddressDetails addressDetails={candidateData.addresses} />
        </React.Fragment>
      ) : documentsLoading ? (
        <div className="d-flex align-items-center justify-content-center pt-5 mt-5">
          <img src={CDKSpinner} className="pt-5 mt-5" alt="loading..." />
        </div>
      ) : (
        <React.Fragment>
          <div className="container text-right">
            {/* <Icon
              align="right"
              className="text-right"
              onClick={() => {
                window.print();
              }}
            >
               file_download
            </Icon> */}
          </div>
          {userDocuments.length > 0 ? (
            <ViewUserDocuments userDocuments={userDocuments} isAdmin={true} />
          ) : (
            <div className="d-flex  justify-content-center pt-5 mt-5">
              <h6 className="pt-5 mt-5">User Documents are not available</h6>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};
export default CandidateReport;
